let shippingEls = document.getElementsByName("shipping");
let paymentsEls = document.getElementsByName("payment");

function setDisabled(elements) {
	elements.forEach((el) => {
		el.setAttribute("disabled", "disabled");
	});
}

function removeChecked(elements) {
	elements.forEach((el) => {
		el.removeAttribute("checked");
		el.checked = false;
	});
}

function getPayment(id) {
	return document.getElementById("frm-paymentAndShippingForm-payment-" + id);
}

function getAvaPayments(element) {
	return JSON.parse(element.getAttribute("data-availablepayments"));
}

function makePaymentsVisible(paymentId) {
	const payment = getPayment(paymentId);
	payment.removeAttribute("disabled");
}

function togglePayments(element) {
	const avaPayments = getAvaPayments(element);
	avaPayments[element.value].forEach((value) => {
		makePaymentsVisible(value);
	});
}

if (paymentsEls) {
	setDisabled(paymentsEls);
}

if (shippingEls) {
	shippingEls.forEach(el => {
		if (el.checked) {
			const avaPayments = getAvaPayments(el);
			avaPayments[el.value].forEach((value) => {
				makePaymentsVisible(value);
			});
		}

		el.addEventListener("change", (event) => {
			const element = event.currentTarget;

			setDisabled(paymentsEls);
			removeChecked(paymentsEls);

			togglePayments(element);
		});
	});
}
